import * as React from 'react';
import styled from 'styled-components';
const StyleDiv = styled.div `
  display: inline-block;
  text-align: center;
  vertical-align: middle;

  svg {
    fill: #a00;
  }
`;
class IconX extends React.Component {
    render() {
        return (React.createElement(StyleDiv, { className: this.props.className, onClick: this.props.clicked },
            React.createElement("svg", { width: this.props.width, height: this.props.height, viewBox: "0 0 28 28" },
                React.createElement("g", null,
                    React.createElement("g", { id: "c142_x" },
                        React.createElement("path", { d: "M13.98,0C6.259,0,0,6.261,0,13.983c0,7.721,6.259,13.982,13.98,13.982c7.725,0,13.985-6.262,13.985-13.982\n                C27.965,6.261,21.705,0,13.98,0z M19.992,17.769l-2.227,2.224c0,0-3.523-3.78-3.786-3.78c-0.259,0-3.783,3.78-3.783,3.78\n                l-2.228-2.224c0,0,3.784-3.472,3.784-3.781c0-0.314-3.784-3.787-3.784-3.787l2.228-2.229c0,0,3.553,3.782,3.783,3.782\n                c0.232,0,3.786-3.782,3.786-3.782l2.227,2.229c0,0-3.785,3.523-3.785,3.787C16.207,14.239,19.992,17.769,19.992,17.769z" }))))));
    }
}
;
export default IconX;
//# sourceMappingURL=IconX.js.map


// WEBPACK FOOTER //
// ./src/components/IconX.js